require("core-js/modules/es.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.personRouter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var person = {
    path: '/person',
    redirect: '/person/regionalScreen/:id',
    name: 'DeviceList',
    component: function component() {
      return import('@/Layout');
    },
    meta: {
      title: '设备列表'
    },
    children: [{
      path: 'regionalScreen/:id',
      component: function component() {
        return import('@/pages/person/regionalScreen');
      },
      name: 'RegionalScreen',
      meta: {
        title: '养殖终端大屏'
      }
    }]
  };
  var _default = person;
  _exports.default = _default;
});